import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-priority-tag',
  templateUrl: './priority-tag.component.html',
  styleUrl: './priority-tag.component.scss',
})
export class PriorityTagComponent {
  @Input() backgroundColor: string = 'white';
  @Input() borderColor: string = 'black';
  @Input() label: string = '';
  @Input() textColor: string = 'black';
  selectedTextColor = 'white';
  selectedBgColor = 'black';

  selected = false;

  onTagChecked(event: any) {
    this.selected = event;
  }
}
